import PropTypes from 'prop-types'
import { ReactTooltipStyled } from '../styled/typography/typographyExtentions'
import { PhaseDiv } from './_Styled'
import useLexicon from '../../hooks/useLexicon'

const Phase = ({ size, phase, tipPlacement, masterCourseId }) => {
  const lexicon = useLexicon()

  return phase ? (
    <PhaseDiv
      size={size}
      className="phase"
      data-tip={lexicon.curriculum_phases_name && lexicon.curriculum_phases_name[phase.id] ? lexicon.curriculum_phases_name[phase.id] : phase.name}
      data-for={`${masterCourseId}-phase-${phase.id}`}
    >
      {lexicon.curriculum_phases_abb && lexicon.curriculum_phases_abb[phase.id] ? lexicon.curriculum_phases_abb[phase.id] : phase.abbreviation}
      <ReactTooltipStyled
        id={`${masterCourseId}-phase-${phase.id}`}
        effect="solid"
        place={tipPlacement}
      />
    </PhaseDiv>
  ) : null
}

Phase.defaultProps = {
  size: 25,
  tipPlacement: 'top'
}

Phase.propTypes = {
  phase: PropTypes.object,
  size: PropTypes.number.isRequired,
  tipPlacement: PropTypes.string.isRequired,
  masterCourseId: PropTypes.number
}

export default Phase
